import React, { useState } from 'react'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'
import styled, { css } from 'styled-components'
import SimpleBoardTable from './SimpleBoardTable'
import PlayerPanelShared from '../components/PlayerPanelShared'

import { useStore } from '../zustandStore'
import { shallow } from 'zustand/shallow'

const PublicPlayersPage = (props) => {
  const [query, setQuery] = useSearchParams()
  const { eventSlug, playerSlug } = useParams()
  const navigate = useNavigate()

  const {
    // hasDivisions,
    // divisionNames,
    divisions,
    players,
    // TEMP PLAYERS_NEW
    playersNew,
  } = useStore(state => ({
    // hasDivisions: state.event.hasDivisions,
    // divisionNames: state.event.divisionNames,
    divisions: state.divisions,
    players: state.players,
    playersNew: state.playersNew,
  }), shallow)


  const onClickPlayerRow = (clickedPlayerSlug) => (e) => {
    e.preventDefault()
    // console.log({clickedPlayerSlug})
    navigate(`/${eventSlug}/players/${clickedPlayerSlug}`, {replace: true})
    // if (pinnedPlayerSlugs.includes(clickedPlayerSlug)) {
    //   setFlashingPlayerSlugs(flashingPlayerSlugs.filter(slug => slug !== clickedPlayerSlug))
    //   setTimeout(() => setFlashingPlayerSlugs([...flashingPlayerSlugs, clickedPlayerSlug]), 1)
    // } else {
    //   setQuery({ pin: [...pinnedPlayerSlugs, clickedPlayerSlug] }, { replace: true })
    // }

  }


  return (
    <StyledPageWrapper>
      <StyledSimpleBoardWrapper>
        <SimpleBoardTable
          players={players} // TODO: convert to slugs only
          wrapperClassName='table-non-pinned-wrapper'
          tableClassName='players-table'
          // hasOddOffset={hasOddOffset}
          scaleBy={0.9}
          scaleByOnPhone={0.75}
          onClickPlayerRow={onClickPlayerRow}
          // livePlayerSlugs={obsState.livePlayerSlugs}
        />
      </StyledSimpleBoardWrapper>
      <PlayerPanelStylingWrapper>
        <PlayerPanelShared player={playersNew[playerSlug]}/>
      </PlayerPanelStylingWrapper>
    </StyledPageWrapper>
  )
}

export default PublicPlayersPage

const StyledPageWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 75%;
  margin-left: auto;
  margin-right: auto;
`

const StyledSimpleBoardWrapper = styled.div`

  --row-hover-color: var(--blue-hover);
  --row-active-color: var(--blue-active);


  /* width: min-content; */

  max-height: 47vh;
  overflow-y: scroll;

  display: flex;
  justify-content: center;
  flex-flow: row nowrap;
  margin-bottom: 2.5em;
  /* padding-left: 2%; */
  /* padding-right: 2%; */
  /* max-width: min(94vw, 1200px); */
  margin-left: auto;
  margin-right: auto;

  .row {
    min-width: unset;
  }

  .table-non-pinned-wrapper {
    height: fit-content;
  }

  .players-table {

    width: 100%;
    max-width: 100%;
  }

  border: 1px solid #aaa;
  padding: 2px;
  border-radius: 2px;

  width: 35%;

  .table-non-pinned {
    &:not(.no-border-top) {
      /* border-top: 1px solid #aaa; */
    }
    /* border-bottom: 1px solid #aaa; */
    /* max-width: 26.25em;
    margin-left: 0.5em;
    margin-right: 0.5em; */
  }
/* 
  @media only screen and (max-width: ${() => `${window.phoneCutoffSizePx}px`}) and (orientation: portrait) {
    flex-flow: column nowrap;
    padding-bottom: 5px;
    padding-left: 5px;
    padding-right: 5px;

    .table-non-pinned {
      border: 0;
      max-width: 95vw;
    }

    .table-non-pinned-wrapper:first-child {
      .table-non-pinned {
        .row:first-child {
          border-top: 1px solid #aaa;
        }
      }
    }

    .table-non-pinned-wrapper:last-child {
      .table-non-pinned {
        .row:last-child {
          border-bottom: 1px solid #aaa;
        }
      }
    }
  } */

  .row:hover {
    border-top: 1px solid var(--every-other-row-color);
    border-bottom: 1px solid var(--every-other-row-color);
    cursor: pointer;
  }
`


const PlayerPanelStylingWrapper = styled.div`
  ${'' /* controls width of player section */}
  width: 35%;
  --font-size: 31px;

  /* position: fixed; */
  /* position: fixed prevents the panel from ever being scrolled on the off chance this browser source is not tall enough for its contents and the autoscrolling board below it makes it move */
  margin-left: auto;
  margin-right: auto;
  /* padding-bottom: 10px;
  margin-bottom: 0px; */

  .panel-wrapper {
    /* height: 73.5vh; */
    border: 2px solid #aaa;
    border-radius: 4px;
    padding-bottom: 0.3em;
  }

  .chapter-times-body {
    font-size: 1.05em;
    line-height: 1.4em;
  }


  .player-title {
    ${'' /* padding-top: 0.29em;
    padding-bottom: 0.116em;
    height: 1.45em; */}
    /* border-top-right-radius: 10px; */
    /* border-top-left-radius: 10px; */
    font-size: 1.25em;

  }

  ${'' /* .name-rank-wrapper {
    padding-left: 0.29em; */}
    .rank {
      font-size: 0.66em;
      ${'' /* margin-right: 0.15em;
      padding-bottom: 4px;
      width: 0.87em;
      line-height: 1.4em; */}
    }

    .name {
      line-height: 1em;
      padding-bottom: 0.2em;
    }
  ${'' /* } */}

  .flag {
    --flag-width: 62px;
    ${'' /* margin-top: 1em; */}
  }
`